var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#BBBBBB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2164 19.1503L25.0347 17.3321C25.4327 16.9341 25.9051 16.6184 26.4251 16.403C26.945 16.1877 27.5023 16.0768 28.0651 16.0768C28.628 16.0768 29.1853 16.1877 29.7052 16.403C30.2252 16.6184 30.6976 16.9341 31.0956 17.3321C31.4936 17.73 31.8093 18.2025 32.0246 18.7224C32.24 19.2424 32.3509 19.7997 32.3509 20.3625C32.3509 20.9253 32.24 21.4826 32.0246 22.0026C31.8093 22.5226 31.4936 22.995 31.0956 23.393L29.2773 25.2113M25.6408 28.8478L23.8225 30.6661C23.4245 31.064 22.9521 31.3797 22.4321 31.5951C21.9122 31.8105 21.3549 31.9213 20.792 31.9213C19.6554 31.9213 18.5653 31.4698 17.7616 30.6661C16.9579 29.8624 16.5063 28.7723 16.5063 27.6356C16.5063 26.499 16.9579 25.4089 17.7616 24.6052L19.5799 22.7869",
    stroke: "white",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0043 26.4236L26.853 21.5748",
    stroke: "white",
    strokeWidth: 2.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon_link.addf8296d9adf9cdf8942b2de24443ec.svg";
export { ForwardRef as ReactComponent };